import EmrFormItem from '@/screens/CreateEmr/EmrInput/EmrFormItem';
import { IEmrInputProps } from '@/screens/CreateEmr/EmrInput/EmrInput';
import { DatePicker } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import dayjs, { Dayjs } from 'dayjs';
import * as React from 'react';

export interface IEmrRangePickerProps extends Pick<IEmrInputProps, 'name' | 'field' | 'labelProps'> {
  rangePickerProps: RangePickerProps;
}

const EmrRangePicker: React.FC<IEmrRangePickerProps> = ({
  rangePickerProps: { renderExtraFooter, ...rangePickerProps },
  labelProps = {},
  ...props
}) => {
  const [dates, setDates] = React.useState<Dayjs[]>([]);

  const ref = React.useRef<any>(null);

  const onCalendarChange = (dates: Dayjs[]) => {
    setDates(dates);
  };
  const disabledDate = (current: Dayjs) => {
    if (!dates || dates.length === 0) {
      return false;
    }

    const start = dates[0];
    const end = dates[1];

    if (start && !end) {
      return current && current < start.startOf('day');
    }

    return false;
  };

  return (
    <EmrFormItem
      getValueProps={(value?: String[]) => {
        return { value: value?.map?.((d) => dayjs(d as string)) };
      }}
      getValueFromEvent={(val: Dayjs[]) => {
        return val?.map((d) => d.toISOString());
      }}
      labelCol={{ span: 24 }}
      {...labelProps}
    >
      <DatePicker.RangePicker
        ref={ref}
        disabledDate={disabledDate}
        onCalendarChange={(dayjsArray) =>
          onCalendarChange([dayjsArray[0] as unknown as Dayjs, dayjsArray[1] as unknown as Dayjs])
        }
        className={'base-range-picker w-full '}
        rootClassName={`root-base-range-picker`}
        renderExtraFooter={(mode) => {
          return renderExtraFooter ? renderExtraFooter.call(ref.current, mode) : '';
        }}
        {...rangePickerProps}
      />
    </EmrFormItem>
  );
};
export default EmrRangePicker;
